import { Flex, Text, Tooltip } from '@electricjs/arc';
import { LockStatus } from '@electricjs/core_entity-client';
import { useTranslation } from 'react-i18next';
import { DeviceDataAction } from '../types';
import DeviceRadioTile from '../DeviceRadioTile';

type LockDeviceRadioOptionProps = {
  lockStatus: LockStatus | undefined;
  value: DeviceDataAction | undefined;
  disabled: boolean;
};

const LockDeviceRadioOption = ({
  lockStatus,
  value,
  disabled,
}: LockDeviceRadioOptionProps) => {
  const { t } = useTranslation('common');
  const isLocked = lockStatus === LockStatus.Locked;
  const isLockRequested = lockStatus === LockStatus.Requested;
  const getDisabledLockMessage = () => {
    if (isLocked) {
      return t('offboardings.deviceData.lockTooltips.alreadyLocked');
    }
    if (isLockRequested) {
      return t('offboardings.deviceData.lockTooltips.lockRequested');
    }
    return '';
  };
  const disableLockOption = disabled || isLocked || isLockRequested;

  return (
    <Tooltip
      placement="top-start"
      content={<Text>{getDisabledLockMessage()}</Text>}
      disabled={disabled || (!isLocked && !isLockRequested)}>
      <Flex>
        <DeviceRadioTile
          value={DeviceDataAction.Lock}
          optionText={t('offboardings.deviceData.options.lock')}
          icon="lock"
          checked={value === DeviceDataAction.Lock}
          disabled={disableLockOption}
        />
      </Flex>
    </Tooltip>
  );
};

export default LockDeviceRadioOption;
